import { useContext, useEffect, useState } from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import PageBuilder from '../../../library/Builders/PageBuilder/PageBuilder';
import { GlobalContext } from '../../../library/Core/GlobalContext';
import { SmartContext } from '../../../library/Core/SmartContext';
import { isEmpty, isFormValid, isGrievanceCategoryPushedOnly, setError } from '../../../library/Core/SmartFunctions';
import smartReducer from '../../../library/Core/SmartReducer';
import { ControlOnChangeArguments, DispatchEvent, State } from '../../../library/Core/SmartTypes';
import { axiosClient } from '../../../library/Service/axiosClient';
// import { onMobileCountryCodeChange, onMobileNumberChange, twelthPassoutYear } from './GrievanceActions';
import Layout from './Layout';
import { getinstituteList } from '../../../library/Service/domainService';
import useManagementDashboard from '../../management/dashboard/useManagementDashboard';
import SessionContext from '../../../library/Core/SessionContext';
import axios from 'axios';
import Swal from 'sweetalert2';
import { on } from 'events';

const Grievance = () => {
    const { globalState } = useContext(GlobalContext);
    const { getCampuses } = useManagementDashboard();
    const navigate = useNavigate();
    const { internal } = useLoaderData() as State;
    const { sessionState } = useContext(SessionContext);

    // const campuses = getCampuses();
    const campuses =(sessionState?.userTypeCode=='INSTITUTE_ADMIN') ?  getCampuses() : globalState.domain.get('INSTITUTE_DOMAIN')?.map((data) => {
        return {label:data.value, value:data.code};
    });

    const [instituteList, setinstituteList] = useState(getinstituteList('INSTITUTE_GROUP_CODE', campuses));

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {
            SAVE: handleCreate,
            CANCEL: (event: React.SyntheticEvent<HTMLButtonElement>, state: State, dispatch: (dispatchEvent: DispatchEvent) => void) => {
                event.preventDefault();
                navigate(-1);
            },
            category: onChangeCategory,
            // passOutYear: twelthPassoutYear,
            // mobileNumber: onMobileNumberChange,
            // mobileCountryCode: onMobileCountryCodeChange,
        },
    } as any);

    function onChangeCategory (props: ControlOnChangeArguments)  {
        const selectedCategoryCode = props.value;
        const isInternal = isGrievanceCategoryPushedOnly(selectedCategoryCode, props.state);
        dispatch({ type: 'CONTROL_VALUE_CHANGE', payload: { dataKey: 'grievance.isInternal', value: isInternal ? '1' : '0' } });
    }

    function handleCreate(
        event: React.SyntheticEvent<HTMLButtonElement>,
        state: State,
        dispatch: (dispatchEvent: DispatchEvent) => void,
        globalState: any,
        globalDispatch: (dispatchEvent: DispatchEvent) => void
    ) {
        
        event.preventDefault();
       
        let ignoreKeys = ['grievance.email','grievance.name', 'grievance.program', 'grievance.batch'];
        if (state.data?.grievance?.leadType === 'manual') {
            ignoreKeys = ['grievance.studentId'];
        }

        if (isEmpty(state.data?.grievance?.instituteId)) {
            const errorMessages = [];
            setError('grievance.instituteId', [`Please enter "Institute name"`], dispatch);
            errorMessages.push(`Please enter "Institute name"`)
            // dispatch({
            //     type: 'SET_FIELD_VALIDATION_ERRORS',
            //     payload: { dataKey: 'grievance.instituteId', errorMessages },
            // });
            dispatch({ type: 'SHOW_ERRORS' });

            return;
        }

        if (!isFormValid(state, dispatch, ignoreKeys) || isEmpty(state.data?.grievance?.instituteId)) {
            return;
        }

        dispatch({ type: 'SET_BUSINESS_VALIDATION_ERRORS', payload: [] });

        let url = `${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/grievance/add`;     

        axiosClient()
            .post(`${url}`, {
                ...state.data.grievance
            })
            .then((res: any) => {
                const responseUserData = res.data as any;
                // dispatch({ type: 'SET_BUSINESS_VALIDATION_ERRORS', payload: [responseUserData] });

                Swal.fire({
                    title: responseUserData.success ? 'Success!' : 'Error!',
                    text: responseUserData.message,
                    icon: responseUserData.success ? 'success' : 'error'
                }).then(() => {
                    if (!responseUserData.success) {
                        return;
                    }
                    
                    if (sessionState?.userTypeCode === 'INSTITUTE_ADMIN') {
                        navigate(`/management/grievance-v2`);
                    } else {
                        navigate(`/support/grievance-v2`);
                        // navigate(`/support/grievance-management`);
                    }
                });

                dispatch({ type: 'SET_BUSINESS_VALIDATION_ERRORS', payload: [responseUserData] });
            })
            .catch((err: any) => {
                if (err.response && err.response.status === 409) {
                    // Handle conflict error (HTTP 409)
                    alert('The user already exists.');
                } else {
                    // Handle other errors
                    console.error(err);
                    alert('An error occurred during registration. Please try again later.');
                }
            });
    }

    const { formConfig, data, routeInfo } = useLoaderData() as State;

    useEffect(() => {
        const domain = new Map([...globalState.domain]);

        const allCategories = domain.get('GRIEVANCE_CATEGORY') ?? [];
        const dynamicCategories =
            sessionState?.userTypeCode === 'SUPER_ADMIN'
                ? [...allCategories]
                : allCategories.filter((element: any) => {
                      if (isEmpty(element.flexCol)) return true;
                      try {
                          const config = JSON.parse(element.flexCol);
                          return !(config.pushed_only === 1 || config.pushed_only === true);
                      } catch {
                          return true;
                      }
                  });
        domain.set('GRIEVANCE_CATEGORY_DYNAMIC', dynamicCategories);

        dispatch({
            type: 'DATA_INIT',
            payload: {
                formConfig,
                data: { 
                    ...data,
                    grievance : {
                        leadType: 'system',
                        isInternal: '0',
                        triggerEmail: false
                    },
                    institute : {
                        instituteGrouId: sessionState?.instituteGroupId,
                        instituteIdSession: sessionState?.institutes
                    },
                    userTypeCode : sessionState?.userTypeCode
                },
                domain,
                routeInfo,
            },
        });

        const setDomainData = async () => { 
            try {
                // console.log(instituteList,'instituteList');
                if(instituteList.length > 1) {
                    dispatch({
                        type: 'SET_DOMAIN',
                        payload: { key: 'INSTITUTE_GROUP_CODE', value: instituteList },
                    });
                }
                else if(instituteList.length == 1)
                {
                    dispatch({ type: 'CONTROL_VALUE_CHANGE', payload: { dataKey :'grievance.instituteId',value: instituteList[0].code } });
                    await fetchData();
                }
            } catch (error) {
                console.error('Error fetching program data:', error);
            }
        };
    
        setDomainData();
    }, []);

    async function fetchData() {
        try {
            if(state.data?.user?.instituteId){
                const response = await axiosClient().post(`${process.env.REACT_APP_INTERNAL_ADMIN_SERVER}/user/get-programs-by-institute-id`, {
                    institute_id: state.data?.user?.instituteId,
                });
                const programs = response.data.data.programs;
                let program_values = [];
                for(let i = 0; i < programs.length;i++)
                {
                    program_values[i] = {'label' : programs[i]['name'],'value': programs[i]['id']};
                }
                
                dispatch({
                    type: 'SET_DOMAIN',
                    payload: { key: 'INSTITUTE_ATTENDED_PROGRAM_CODE', value: getinstituteList('INSTITUTE_ATTENDED_PROGRAM_CODE', program_values) },
                });
            }
        } catch (error) {
            console.error('Error fetching program data:', error);
        }
    }

    useEffect(() => {
        if(state.data?.user?.instituteId != undefined){
            fetchData();
        }
    }, [state.data?.user?.instituteId]);

    useEffect(() => {
        if (state.data?.grievance?.leadType === 'manual') {
            dispatch({
                type: 'CONTROL_VALUE_CHANGE',
                payload: { dataKey: 'grievance.studentId', value: '' },
            });
        }
    }, [state.data?.grievance?.leadType]);

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <Layout>{!state.flags.isDataLoading && <PageBuilder />}</Layout>
        </SmartContext.Provider>
    );
};

export default Grievance;
